// B: This is needed for support of older browsers like chrome <110 (Alicja's chrome is 103xD)

// ES2023 array methods - some simple shims
if (!Array.prototype.toReversed) {
  Object.defineProperty(Array.prototype, 'toReversed', {
    value: function () { return [...this].reverse() },
  })
}

if (!Array.prototype.toSorted) {
  Object.defineProperty(Array.prototype, 'toSorted', {
    value: function (cmp) { return [...this].sort(cmp) },
  })
}

if (!Array.prototype.toSpliced) {
  Object.defineProperty(Array.prototype, 'toSpliced', {
    value: function (start, deleteCount, ...items) {
      const arr = [...this]
      arr.splice(start, deleteCount ?? 0, ...items)

      return arr
    },
  })
}

if (!Array.prototype.with) {
  Object.defineProperty(Array.prototype, 'with', {
    value: function (index, value) {
      const arr = [...this]
      const i = index < 0 ? arr.length + index : index // B: obsługa indeksów ujemnych
      arr[i] = value

      return arr
    },
  })
}


//#869bycu2h
if (!Array.prototype.at) {
  Object.defineProperty(Array.prototype, 'at', {
    value: function (index) {
      index = Math.trunc(index) || 0
      if (index < 0) index += this.length
      if (index < 0 || index >= this.length) return undefined

      return this[index]
    },
    writable: true,
    enumerable: false,
    configurable: true
  })
}

if (!String.prototype.at) {
  Object.defineProperty(String.prototype, 'at', {
    value: function (index) {
      index = Math.trunc(index) || 0
      if (index < 0) index += this.length
      if (index < 0 || index >= this.length) return undefined

      return this.charAt(index)
    },
    writable: true,
    enumerable: false,
    configurable: true
  })
}

if (!Array.prototype.findLast) {
  Object.defineProperty(Array.prototype, 'findLast', {
    value: function (predicate, thisArg) {
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function')
      }

      const arr = Object(this)
      const len = arr.length >>> 0

      for (let i = len - 1; i >= 0; i--) {
        if (i in arr) {
          const value = arr[i]
          if (predicate.call(thisArg, value, i, arr)) {
            return value
          }
        }
      }

      return undefined
    },
    writable: true,
    enumerable: false,
    configurable: true
  })
}
